import { FunctionComponent } from "react"
import { Container, Row } from "react-grid-system"
import styled from "styled-components"
import { HorizontalSpacer } from "../../atoms/spacers"
import { theme } from "../../theme"
import * as React from "react"
import { Link, useNavigate } from "react-router-dom"
import { CartStructure, Product } from "../../interfaces/SaleorTypes"
import { calculateSubtotal, getFormattedPrice } from "../../../utils/cart-helpers"
import Card from "../../atoms/Card"
import Subtitle from "../../atoms/typography/Subtitle"
import BodyLarge from "../../atoms/typography/BodyLarge"
import BodyMedium from "../../atoms/typography/BodyMedium"
import SecondaryButton from "../../atoms/buttons/SecondaryButton"
import TextButton from "../../atoms/buttons/TextButton"
import { ShareIcon } from "../../atoms/icons/ShareIcon"
import Line from "../../atoms/Line"
import CartSolutionSection from "../../molecules/store/cart/CartSolutionSection"
import { CartSolutionOrder } from "../../../utils/models"
import CartAccessorySection from "../../molecules/store/cart/CartAccessorySection"

interface CartPageProps {
  cart: CartStructure[]
  removeFromCart: (products: CartStructure[]) => void
  addToCart: (products: CartStructure[]) => void
  updateItemInCart: (item: Product) => void
  solutions: CartSolutionOrder[]
  removeSolution: (id: string) => void
}

const SummaryBanner = styled.div`
  background-image: ${(props) => props.theme.gradients.blue};
  padding: 1rem;
  border-radius: ${(props) => props.theme.borders.smallRadius};
`

/**
 * This component is mainly for the mobile version of the cart
 */
const CartPage: FunctionComponent<CartPageProps> = ({
  cart,
  removeFromCart,
  addToCart,
  updateItemInCart,
  solutions,
  removeSolution,
  ...props
}) => {
  const terminals = cart.filter((item) => item.product.category.name == "Terminals")

  const accessories = cart.filter((item) => item.product.category.name == "Accessories")

  const navigate = useNavigate()

  const onClickGoToCheckout = () => {
    navigate("/store/checkout")
  }

  return (
    <>
      <HorizontalSpacer spacing={3} />

      <Container>
        <Card>
          <HorizontalSpacer spacing={2} />
          <Subtitle>Cart</Subtitle>
          <HorizontalSpacer spacing={2} />
          {terminals && terminals.length > 0 && (
            <div>
              <BodyMedium>Terminals</BodyMedium>
              <Line />
              <HorizontalSpacer spacing={1} />

              <CartSolutionSection
                solutions={solutions}
                removeFromCart={removeFromCart}
                removeSolution={removeSolution}
                editable
              />
            </div>
          )}

          <HorizontalSpacer spacing={2} />
          {accessories && accessories.length > 0 && (
            <div>
              <BodyMedium>Accessories</BodyMedium>
              <Line />
              <HorizontalSpacer spacing={1} />

              {accessories.map((accessories: CartStructure, index: number) => (
                <CartAccessorySection
                  key={`${accessories.product.id} ${index}`}
                  accessory={accessories}
                  addToCart={addToCart}
                  removeFromCart={removeFromCart}
                  editable
                />
              ))}
            </div>
          )}

          <HorizontalSpacer spacing={8} />

          <SummaryBanner>
            <BodyLarge color={theme.colors.white} textAlign="center">
              Estimated delivery time: 30 days from order confirmation
            </BodyLarge>
            <HorizontalSpacer spacing={1} />
            <BodyLarge color={theme.colors.white} textAlign="center">
              Total: {getFormattedPrice(calculateSubtotal(cart), cart[0]?.product.variants[0].pricing.price.currency)}
            </BodyLarge>
          </SummaryBanner>

          <HorizontalSpacer spacing={4} />
          <Row align="center" justify="center" gutterWidth={12}>
            <Link to="/privacy_policy" target="_blank" rel="noopener noreferrer">
              <TextButton title="Terms and conditions" icon={<ShareIcon />} />
            </Link>
          </Row>

          <HorizontalSpacer spacing={4} />

          <Row justify="center">
            <Link to="/store/checkout">
              <SecondaryButton title="Checkout" onClick={onClickGoToCheckout} disabled={cart?.length < 1} />
            </Link>
          </Row>
        </Card>
      </Container>

      <HorizontalSpacer spacing={2} />
    </>
  )
}

export default CartPage
